export default class QuotationTypeObj {

    constructor(jsonResponse) {
        if (jsonResponse) {
            this.value = jsonResponse["value"];
            this.displayValue = jsonResponse["display-value"];

            this.id = this.value;
            this.name = this.displayValue;
        }
    }


}
